module.exports = __webpack_public_path__ + "static/media/list.c6244282.svg";